import React from "react";

function Rightimage({imgsrc, title, description}) {
    return (
        <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="about-image-content">
                    <img src={imgsrc} alt="about" className="product-img" />
                </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="about-text-content">
                    <div className="about-tltle">
                        <h2 className="">{title}</h2>
                    </div>
                    <div className="description">
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Rightimage;